export const UnleashKeys = {
  akerbp_custom_code: 'INFIELD.akerbp_custom_code',
  INFIELD_IS_AWS_PROJECT: 'INFIELD_IS_AWS_PROJECT',
  windows_tablet_camera_oxy: 'INFIELD.windows_tablet_camera_oxy',
  INFIELD_SEARCH_EVERYTHING_IS_ENABLED: 'INFIELD_SEARCH_EVERYTHING_IS_ENABLED',
  INAPP_SELF_SERVICE_RELEASE_MANAGEMENT:
    'INAPP_SELF_SERVICE_RELEASE_MANAGEMENT',
  RELEASE_Q1_2025: 'INFIELD.RELEASE_Q1_2025',
  checklist_table_createdby: 'INFIELD.checklist_table_createdby',
  checklist_scheduler: 'INFIELD.checklist_scheduler',
  schedule_tab: 'INFIELD.schedule_tab',
  celanese_corrupted_readings: 'INFIELD.celanese_corrupted_readings',
  mobile_template: 'INFIELD.mobile_template',
  save_config_confirmation: 'INFIELD.save_config_confirmation',
  numerical_keyboard: 'INFIELD.NUMERICAL_KEYBOARD',
  save_config_disabled: 'INFIELD.save_config_disabled',
  latest_numerical_reading: 'INFIELD.latest_numerical_reading',
  set_checklist_to_done_modal: 'INFIELD.SET_CHECKLIST_TO_DONE_MODAL',
};
